import { ScribeHowTutorial, TutorialSection } from "../types/tutorials"

const HOW_TO_CREATE_ORGANIZATION_TUTORIAL: ScribeHowTutorial = {
    title: "How to Create an Organization?",
    description: "Learn how to set up a new organization, manage its settings, and invite team members.",
    // scribeHowEmbedLink: 'https://scribehow.com/embed/Create_a_New_Organization_in_Tutorial__xOk5FTBHR2ux7nLVSd_Ztw?skipIntro=true'
    scribeHowEmbedLink: 'https://scribehow.com/embed/Create_a_New_Organization__nk88ePsURKqTBPsfpEYtAw?skipIntro=true'
}

const HOW_TO_CREATE_PROJECT_TUTORIAL: ScribeHowTutorial = {
    title: "How to Create a Project?",
    description: "Step-by-step guide to creating a project within an organization, assigning members, and setting export parameters.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Create_a_New_Project_and_Collaborate__cmm1aOyeS360N-9NFesgFw?skipIntro=true'
}

const HOW_TO_CREATE_SURVEY_TUTORIAL: ScribeHowTutorial = {
    title: "How to Create a Survey?",
    description: "Instructions on how to create a survey, and define basic settings.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Create_a_Tutorial_Survey_and_Add_a_Custom_Question__1gjLTRm0RZ-HMs_kl6LwXw?skipIntro=true'
}

const HOW_TO_ADD_QUESTIONS_TUTORIAL: ScribeHowTutorial = {
    title: "How to Add Questions?",
    description: "Find out how to add questions to a survey and define export parameters.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/How_to_Add_a_Custom_Question_to_a_Survey__PCel08bJS2CF4Kr-K-hGZw?skipIntro=true'
}

const HOW_TO_COPY_SURVEY_TO_ANOTHER_PROJECT_TUTORIAL: ScribeHowTutorial = {
    title: "How to copy a survey to different projects?",
    description: "Step-by-step guide to copying a survey within organization to another project.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Copy_Survey_to_Another_Project__nrEuoF3SSEac14QX0WZHGA?skipIntro=true'
}

const HOW_TO_SAVE_SURVEY_AS_TEMPLATE_TUTORIAL: ScribeHowTutorial = {
    title: "How to save a project as template?",
    description: "This guide provides a straightforward process for saving a project as a template, which can streamline future project creation and enhance efficiency.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Save_Project_as_Template__nXmQuf46TQmR-1dMTD3fWA?skipIntro=true'
}

const HOW_TO_USE_SURVEY_TEMPLATE_TUTORIAL: ScribeHowTutorial = {
    title: "Copy a Survey Template to a Project",
    description: "This guide provides a straightforward process for copying a survey template to a project, ensuring efficiency in survey management.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Copy_a_Survey_Template_to_a_Project__2aCh0LIKRoW1YuiKOksMtQ?skipIntro=true'
}

const HOW_TO_EXPORT_SURVEY_TUTORIAL: ScribeHowTutorial = {
    title: "How to export a survey?",
    description: "Instructions on how to export a survey and its responses.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Export_Survey_Question_Values_With_Errors__K5iKdZ_MRAeMTmaHcIQnSA?skipIntro=true'
}

const HOW_TO_CREATE_CRM_WITH_PARAMETERS_TUTORIAL: ScribeHowTutorial = {
    title: "How to create a CRM configuration with custom parameters?",
    description: "Learn how to set up a new CRM configuration with custom parameters to enhance your survey management.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/Add_New_CRM_Configuration_With_Custom_Parameters__eTgZLnL7ReaNI7zZygLPig?skipIntro=true',
}

const HOW_TO_CREATE_CRM_PROJECT_TUTORIAL: ScribeHowTutorial = {
    title: "How to create a CRM configuration for a project?",
    description: "Learn how to set up a new CRM configuration for your project to enhance your survey management.",
    scribeHowEmbedLink: 'https://scribehow.com/embed/How_to_Add_a_CRM_Project_Configuration__sssQNvjzR8aMplsRpW-oVA?skipIntro=true',
}


export const HOMEPAGE_TUTORIALS: ScribeHowTutorial[] = [
    HOW_TO_CREATE_ORGANIZATION_TUTORIAL,
    HOW_TO_CREATE_PROJECT_TUTORIAL,
    HOW_TO_CREATE_SURVEY_TUTORIAL,
    HOW_TO_ADD_QUESTIONS_TUTORIAL
]

export const ORGANIZATION_HOMEPAGE_TUTORIALS: ScribeHowTutorial[] = [
    HOW_TO_COPY_SURVEY_TO_ANOTHER_PROJECT_TUTORIAL,
    HOW_TO_SAVE_SURVEY_AS_TEMPLATE_TUTORIAL,
    HOW_TO_USE_SURVEY_TEMPLATE_TUTORIAL,
    HOW_TO_EXPORT_SURVEY_TUTORIAL,
    HOW_TO_ADD_QUESTIONS_TUTORIAL
]

export const HELP_SIDEBAR_TUTORIALS: TutorialSection[] = [
    {
        title: "Getting Started",
        description: "Learn how to get started with Collaborate",
        tutorials: [
            HOW_TO_CREATE_ORGANIZATION_TUTORIAL,
            HOW_TO_CREATE_PROJECT_TUTORIAL,
        ]
    },
    {
        title: "Surveys",
        description: "Learn how to create and manage surveys",
        tutorials: [
            HOW_TO_CREATE_SURVEY_TUTORIAL,
            HOW_TO_COPY_SURVEY_TO_ANOTHER_PROJECT_TUTORIAL,
            HOW_TO_SAVE_SURVEY_AS_TEMPLATE_TUTORIAL,
            HOW_TO_EXPORT_SURVEY_TUTORIAL
        ]
    },
    {
        title: "Survey templates",
        description: "Learn how to use survey templates to streamline your survey creation process.",
        tutorials: [
            HOW_TO_USE_SURVEY_TEMPLATE_TUTORIAL,
        ]
    },
    {
        title: "Managing CRM Configurations",
        description: "Learn how to create and manage CRM configurations with custom parameters. These configurations might be used to add additional meta information to your projects or surveys.",
        tutorials: [
            HOW_TO_CREATE_CRM_WITH_PARAMETERS_TUTORIAL,
            HOW_TO_CREATE_CRM_PROJECT_TUTORIAL,
        ]
    }
]